/**
 * Get word ending depend on number
 * @param number
 * @param endings
 */
export const getWordEnding = (
  number: number,
  endings: [string, string, string],
): string => {
  const n = Math.abs(number) % 100;
  const lastDigit = n % 10;

  if (n > 10 && n < 20) {
    return endings[2];
  }

  if (lastDigit > 1 && lastDigit < 5) {
    return endings[1];
  }

  if (lastDigit === 1) {
    return endings[0];
  }

  return endings[2];
};
